import Vimeo from '@u-wave/react-vimeo';
import styles from './VideoPlayer.module.scss';

interface VideoProps {
  url: string | null,
  posterUrl?: string | null,
  autoplay?: boolean,
  type?: 'landscape' | 'portrait',
}

export function VideoPlayer({ url, posterUrl, autoplay = false, type = 'landscape' }: VideoProps) {

  return (
    <div className={ styles.container } data-type= { type }>
      <div className={ styles.containerInner }>

        { posterUrl &&
          <div className={ styles.posterHolder }>
            <img src={ posterUrl } alt='' />
          </div>
        }

        <div className={ styles.embed }>
          { url && (
            <Vimeo
              video={ url }
              controls
              autoplay={ autoplay }
              loop={ false }
              showByline={ false }
              keyboard={ false }
              dnt={ false }
              showPortrait={ false }
              showTitle={ false }
              pip={ false }
              playsInline={ true }
              transparent={ true }
            />
          )}
        </div>

      </div>
    </div>
  );
}
